const componentMargin = {
  margin: "7px",
}
  
const zIndex = {
    zIndex: 3,
  }

const buttonStyle = {
  cursor: 'pointer',
  ...zIndex,
  ...componentMargin,
  borderRadius: '25px',
  border: 'none',
  padding: 15,
}

export const styles = {componentMargin, zIndex, buttonStyle}